var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 6.125V12.1516C6.125 16.4937 9.60312 20.0922 13.9453 20.125C14.9841 20.1322 16.014 19.9338 16.9757 19.5413C17.9375 19.1488 18.8121 18.5699 19.5492 17.8379C20.2862 17.1059 20.8712 16.2353 21.2704 15.2763C21.6695 14.3173 21.875 13.2888 21.875 12.25V6.125C21.875 5.89294 21.7828 5.67038 21.6187 5.50628C21.4546 5.34219 21.2321 5.25 21 5.25H7C6.76794 5.25 6.54538 5.34219 6.38128 5.50628C6.21719 5.67038 6.125 5.89294 6.125 6.125Z",
    fill: "url(#paint0_linear_339_941)",
    stroke: "url(#paint1_linear_339_941)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24.5H17.5",
    stroke: "url(#paint2_linear_339_941)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.125V24.5",
    stroke: "url(#paint3_linear_339_941)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6782 14H22.7501C23.6784 14 24.5686 13.6313 25.225 12.9749C25.8813 12.3185 26.2501 11.4283 26.2501 10.5V8.75C26.2501 8.51794 26.1579 8.29538 25.9938 8.13128C25.8297 7.96719 25.6072 7.875 25.3751 7.875H21.8751",
    stroke: "url(#paint4_linear_339_941)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34395 14H5.23926C4.311 14 3.42076 13.6313 2.76438 12.9749C2.10801 12.3185 1.73926 11.4283 1.73926 10.5V8.75C1.73926 8.51794 1.83145 8.29538 1.99554 8.13128C2.15963 7.96719 2.38219 7.875 2.61426 7.875H6.11426",
    stroke: "url(#paint5_linear_339_941)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_941",
    x1: 14,
    y1: 5.25,
    x2: 14,
    y2: 20.1252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_339_941",
    x1: 14,
    y1: 5.25,
    x2: 14,
    y2: 20.1252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_339_941",
    x1: 14,
    y1: 17,
    x2: 14,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_339_941",
    x1: 13.5,
    y1: 2.5,
    x2: 14.5,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_339_941",
    x1: 18.5005,
    y1: 11,
    x2: 27.5005,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_339_941",
    x1: 9,
    y1: 9,
    x2: 4.0416,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlace);
export default __webpack_public_path__ + "static/media/first-place.12282acd0108809092d58036c1528bd8.svg";
export { ForwardRef as ReactComponent };